import React from "react";
import { SelectPicker as RsuiteSelectPicker } from "rsuite";

const SelectPicker = ({
  title,
  placeholder,
  error,
  name,
  onChange,
  value,
  placement,
  data,
}) => {
  return (
    <div className="input-container d-flex flex-column gap-column-1">
      <small>{title}</small>
      <RsuiteSelectPicker
        size="xs"
        data={data?.map((item) => ({
          label: item.name,
          value: item.id,
        }))}
        className={"input-width"}
        placeholder={placeholder}
        appearance="subtle"
        value={value}
        onChange={(e) => onChange(name, e)}
        placement={placement}
      />
      {error && <small className="error-message text-danger">{error}</small>}
    </div>
  );
};

export default SelectPicker;
